import { useAtom, useSetAtom } from "jotai";
import { recoverDataAtom, pushRecoverStepAtom } from "store/recoverStore";
import { IdentityBirthGenderForm, IdentityBirthGenderResult } from "components/identity/IdentityBirthGenderForm";

/**
 * Step1 (KR 만): 생년월일 + 성별
 *
 * 비밀번호 찾기는 신규 데이터 수집이 아니므로 14세 미만 보호자 동의는 불필요.
 */
export const RecoverStep1 = () => {
    const pushStep = useSetAtom(pushRecoverStepAtom);
    const [data, setData] = useAtom(recoverDataAtom);

    const handleNext = (result: IdentityBirthGenderResult) => {
        setData(prev => ({ ...prev, birth: result.birth, gender: result.gender }));
        pushStep(2);
    };

    return (
        <IdentityBirthGenderForm
            initialBirth={data.birth}
            initialGender={data.gender}
            enableParentConsent={false}
            // KR 전용 화면 — 다음 단계 다날 → genderDigit 필요 → OTHER 차단.
            enableOtherGender={false}
            onNext={handleNext}
        />
    );
};
